import styled from "@emotion/styled";
import { Button } from "@mui/material";
import Divider from "@mui/material/Divider";
import { PageHeader } from "components/Common/Page";

export const LeadDetailsPageHeader = styled(PageHeader)(({ theme }) => ({
	display: "flex",
	padding: "20px 32px",
	flexShrink: 0,
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const LeadDetailsContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	height: "100vh",
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	position: "relative",
	overflow: "hidden",
	[theme.breakpoints.down("lg")]: {
		height: "auto"
	}
}));
export const LeadDetailsScrollableContent = styled.div(({ theme }) => ({
	flex: 1,
	overflowY: "auto",
	"> div: last-of-type": {
		padding: "16px 20px",
		backgroundColor: theme.project.colors.allColors.hex.grayscale.gray100
	}
}));

export const LeadDetailsScrollableContentWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	"> div": {
		padding: 16,
		border: theme.project.borders.presets.outline,
		borderWidth: "1px"
	}
}));

export const StaticComponentGrid = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(2, 1fr)",
	gap: 16,
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const LeadDetailsAutocompletes = styled.div<{ isSold: boolean }>(({ theme }) => ({
	display: "flex",
	flexWrap: "wrap",
	gap: 20,
	"> div": {
		flex: "1 1 calc(50% - 10px)",
		minWidth: 260
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const MessageContainer = styled("div")({
	display: "flex",
	gridColumn: "1 / -1"
});

export const Label = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary
}));

export const NotesLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary,
	display: "grid",
	gridTemplateColumns: "repeat(2, 1fr)",
	marginBottom: 16,
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const InfoText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main
}));

export const NotesInfoText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	display: "flex",
	gridColumn: "1 / -1"
}));

export const StaticComponentTitle = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary,
	marginBottom: 8,
	span: {
		float: "right"
	}
}));

export const LeadDetailsButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "right",
	gap: "16px",
	width: "346px",
	alignSelf: "right",
	button: {
		flex: 1,
		marginTop: 0
	},
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column-reverse",
		width: "100%"
	}
}));

export const LeadDetailsButton = styled(Button)(({ theme }) => ({
	margin: "16px 0 0 0",
	[theme.breakpoints.down("md")]: {
		width: "100%",
		margin: 0
	}
}));

export const BottomStickyRow = styled.div(({ theme }) => ({
	padding: "16px 20px",
	borderTop: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	boxSizing: "border-box",
	display: "flex",
	justifyContent: "right",
	flexShrink: 0,
	zIndex: 5,
	[theme.breakpoints.down("lg")]: {
		padding: "16px",
		position: "fixed",
		bottom: 0,
		width: "100%"
	}
}));

export const SkeletonButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	gap: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		width: "100%",
		margin: "16px 0 0 0"
	}
}));

export const StaticComponentGridDivider = styled(Divider)({
	marginTop: 16,
	marginBottom: 16
});
export const ScrollableNonReadOnlyContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "20px"
});

export const LeadDetailsAccessDenied = styled.div(({ theme }) => ({
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	minHeight: "560px",
	padding: "48px 24px",
	textAlign: "center",
	img: {
		marginBottom: 16,
		maxWidth: 260,
		width: "32%"
	},
	span: {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary
	},
	h2: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.main,
		margin: "24px 0 0 0"
	},
	p: {
		...theme.project.typography.body.body1,
		color: theme.project.colors.fontColors.secondary,
		margin: "12px 0 0 0",
		maxWidth: 455
	}
}));
